import { Col } from 'antd';
import {FC, useMemo} from 'react';
import { JHTML } from '@jnext/commons';
import { ProductContentItem } from '../ProductContent';
import {JBoxInfoWarning} from "../../../../components";
import {useTranslationWord} from "../../../../utils";
import {
    PurchaseDisabledReasonDtoCauseEnum
} from "@jnext/ts-axios-formatdigitalcollection";

export type MainInfoSectionProps = {
    product: ProductContentItem
}

export const MainInfoSection: FC<MainInfoSectionProps> = (props) => {
    const translateWord = useTranslationWord();
    const {product} = props;

    const purchaseDisabledReason = product?.purchaseDisabledReason?.find(el => el.cause == PurchaseDisabledReasonDtoCauseEnum.NeedPlan);

    const ageDisabledReason = product?.purchaseDisabledReason?.find(el =>
        (el.cause == PurchaseDisabledReasonDtoCauseEnum.AgeBetween) || (el.cause == PurchaseDisabledReasonDtoCauseEnum.AgeBelow) || (el.cause == PurchaseDisabledReasonDtoCauseEnum.AgeAbove));

    function getPropsDetail(key:string){
        return (ageDisabledReason?.propsDetails?.[key]);
    }

    const minAge = useMemo(()=>  getPropsDetail('minAge'),[ageDisabledReason])
    const maxAge = useMemo(()=> getPropsDetail('maxAge'),[ageDisabledReason])


    const ageTranslateText = useMemo(()=> {
        if(minAge && maxAge){
            return translateWord('ageDisabledReason', {minAge: minAge, maxAge: maxAge})
        } else if(minAge){
            return translateWord('ageMinDisabledReason', {minAge: minAge})
        } else if(maxAge){
            return translateWord('ageMaxDisabledReason', {maxAge: maxAge})
        }
        return ''
    },[minAge, maxAge])

    return(<Col span={24} className="product-main-info">
            {
                product.title && <JHTML.SectionTitle html={product.title} />
            }
            {
                product.shortDescription && <JHTML.Text html={product.shortDescription}></JHTML.Text>
            }
            {purchaseDisabledReason &&
                <JBoxInfoWarning
                    text={translateWord('purchaseDisabledReason', {title: purchaseDisabledReason?.props ? purchaseDisabledReason?.props[0] : ''})}
                />
            }

            {ageDisabledReason && <JBoxInfoWarning
                text={ageTranslateText}
            />}
        </Col>
    )
}
